import React from "react";

const Tick = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.35"
      height="17.437"
      viewBox="0 0 24.35 17.437"
      style={style}
      stroke="currentColor"
    >
      <path
        id="Tracciato_133"
        d="M-18465-5298.214l6.914,6.914,14.607-14.609"
        transform="translate(18466.414 5307.323)"
        fill="none"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export default Tick;
